import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { useJobPartActions } from 'jobs/hooks';
import { IJobPart } from 'jobs/types';
import { Color } from 'theme/enums';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  jobPart: IJobPart;
}

export const RemoveComponentConfirmation = ({ isOpen, onClose, onSuccess, jobPart }: IProps) => {
  const { t } = useTranslation();

  const { removeJobPartComponent } = useJobPartActions();

  const message = t('messageConfirmRemoveComponent', {
    componentName: jobPart.componentName,
    partNumber: jobPart.partArr?.number,
  });

  const onConfirm = useCallback(async () => {
    onClose();

    if (!jobPart.componentId) {
      return;
    }

    const { success } = await removeJobPartComponent([jobPart.componentId]);

    if (!success) {
      return;
    }

    setTimeout(() => {
      onSuccess?.();
    }, 1000);
  }, [jobPart, removeJobPartComponent, onClose, onSuccess]);

  if (!isOpen) {
    return null;
  }

  return (
    <Confirmation
      isOpen={true}
      title={t('titleRemoveComponent')}
      message={message}
      confirmBtnLabel={t('buttonLabelRemove')}
      confirmBtnColor={Color.DANGER}
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  );
};
